export default __webpack_public_path__ + "static/media/demo5.5a2cf68e.png";